import { DeliveryChannel } from '@pushly/models/lib/enums/delivery-channels.enum'
import { PreviewPlatform } from '@pushly/models/lib/enums/preview-platform'

export const DeliveryChannelPlatforms: Record<DeliveryChannel, PreviewPlatform[]> = {
    [DeliveryChannel.WEB]: [PreviewPlatform.ANDROID, PreviewPlatform.WINDOWS, PreviewPlatform.MAC_OS],
    [DeliveryChannel.NATIVE_ANDROID]: [PreviewPlatform.NATIVE_ANDROID],
    [DeliveryChannel.NATIVE_IOS]: [PreviewPlatform.IOS],
}
